import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { TemperatureInspectionService } from '../temperature-inspection.service';
import { TranslateService } from '../../../translate';
import { UpdateTemperatureDateAmbient } from '../temperature-inspection.module';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-update-ambienttemp-inspection-date-dialog',
  templateUrl: './update-ambienttemp-inspection-date-dialog.component.html',
  styleUrls: ['./update-ambienttemp-inspection-date-dialog.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class UpdateAmbienttempInspectionDateDialogComponent implements OnInit {
InspectionDate:Date;
AmbientTemp:number;
InspectionId:number;
public todate = new Date();
EquipmentSetupDate:Date
userLanguage = 'english';
constructor(
  public _dialogRef: MatDialogRef<UpdateAmbienttempInspectionDateDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any,private _notify: NotificationsService,
  private  _temperatureService: TemperatureInspectionService, private _translate: TranslateService,
  private ref: ChangeDetectorRef, 
) { }

  ngOnInit() {
    this.AmbientTemp=this.data.AmbientTemp;
    this.InspectionDate=this.data.InspectionDate;
    this.InspectionId=this.data.InspectionId;
    this.EquipmentSetupDate=this.data.EquipmentSetupDate;
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  success(title: string, message: string) {
    this._notify.success(title, message);
    this._dialogRef.close(true);
  }

  error(title: string, message: string, err: any) {
    this._notify.error(title, message);
    console.error(err);
  }

  onNoClick() {
    this._dialogRef.close();
  }
  UpdateInspection(){
    

    var d = new Date(this.InspectionDate);
    d.setMinutes( d.getMinutes() + d.getTimezoneOffset() );
    var info= new UpdateTemperatureDateAmbient();
    info.InspectionId = this.InspectionId;
    info.Ambientempearture=this.AmbientTemp;
    info.InspectionDate=this.InspectionDate;//this.InspectionDate.toLocaleString();


    console.log("info",info) 
    this._temperatureService.UpdateInspectionDateTemperature(info).subscribe(r=>{
      if (r.m_Item1) {
        this.success('Saved', r.m_Item2);
      } else {
        this.error('Failed', r.m_Item2, r.m_Item2);
      }
    }, err => {
      this.error('Failed', 'Unable to save Ambient Temperature and Date. Please contact TrackTreads support. ', err);
    });
  }

}
